import { render, staticRenderFns } from "./UsersDashboardView.vue?vue&type=template&id=3ab1ddb2&scoped=true&"
import script from "./UsersDashboardView.vue?vue&type=script&lang=ts&"
export * from "./UsersDashboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1ddb2",
  null
  
)

export default component.exports